import { render, staticRenderFns } from "./outsource_edit.vue?vue&type=template&id=4ba8f261&scoped=true"
import script from "./outsource_edit.vue?vue&type=script&lang=js"
export * from "./outsource_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba8f261",
  null
  
)

export default component.exports